import React, { useEffect, useRef, useState } from 'react';
import ContentEditable from 'react-contenteditable';
import { Scrollbars } from 'react-custom-scrollbars';
import { ReactMediaRecorder } from 'react-media-recorder';
import { api } from '../../Api/app';
import CountdownReverse from './CountdownReverse';

export default function SendMessage({
    sendMessage,
    handleScrollToBottom,
    updateStatusMessage,
    conversation,
    tab,
}) {
    const [message, setMessage] = useState('');

    const [audio, setAudio] = useState('');

    const [video, setVideo] = useState('');

    const [arquivo, setArquivo] = useState('');

    const [sending, setSending] = useState(false);

    const refContentEditable = useRef();

    const emojis =
        '😀 😃 😄 😁 😆 😅 😂 🤣 😊 😇 🙂 🙃 😉 😌 😍 🥰 😘 😗 😙 😚 😋 😛 😝 😜 🤪 🤨 🧐 🤓 😎 🤩 🥳 😏 😒 😞 😔 😟 😕 🙁 😣 😖 😫 😩 🥺 😢 😭 😤 😠 😡 🤬 🤯 😳 🥵 🥶 😱 😨 😰 😥 😓 🤗 🤔 🤭 🤫 🤥 😶 😐 😑 😬 🙄 😯 😦 😧 😮 😲 🥱 😴 🤤 😪 😵 🤐 🥴 🤢 🤮 🤧 😷 🤒 🤕 🤑 🤠 😈 👿 👹 👺 🤡 💩 👻 💀 ☠️ 👽 👾 🤖 🎃 😺 😸 😹 😻 😼 😽 🙀 😿 😾 👋 🤚 🖐 ✋ 🖖 👌 🤏 ✌️ 🤞 🤟 🤘 🤙 👈 👉 👆 🖕 👇 ☝️ 👍 👎 ✊ 👊 🤛 🤜 👏 🙌 👐 🤲 🤝 🙏 ✍️ 💅 🤳 💪 🦾 🦵 🦿 🦶 👣 👂 🦻 👃 👶 👧 🧒 👦 👩 🧑 👨 👩‍🦱 🧑‍🦱 👨‍🦱 👩‍🦰 🧑‍🦰 👨‍🦰 👱‍♀️ 👱 👱‍♂️ 👩‍🦳 🧑‍🦳 👨‍🦳 👩‍🦲 🧑‍🦲 👨‍🦲 🧔 👵 🧓 👴 👲 👳‍♀️ 👳 👳‍♂️ 🧕 👮‍♀️ 👮 👮‍♂️ 👷‍♀️ 👷 👷‍♂️ 💂‍♀️ 💂 💂‍♂️ 🕵️‍♀️ 🕵️ 🕵️‍♂️ 👩‍⚕️ 🧑‍⚕️ 👨‍⚕️ 👩‍🌾 🧑‍🌾 👨‍🌾 👩‍🍳 🧑‍🍳 👨‍🍳 👩‍🎓 🧑‍🎓 👨‍🎓 👩‍🎤 🧑‍🎤 👨‍🎤 👩‍🏫 🧑‍🏫 👨‍🏫 👩‍🏭 🧑‍🏭 👨‍🏭 👩‍💻 🧑‍💻 👨‍💻 👩‍💼 🧑‍💼 👨‍💼 👩‍🔧 🧑‍🔧 👨‍🔧 👩‍🔬 🧑‍🔬 👨‍🔬 👩‍🎨 🧑‍🎨 👨‍🎨 👩‍🚒 🧑‍🚒 👨‍🚒 👩‍✈️ 🧑‍✈️ 👨‍✈️ 👩‍🚀 🧑‍🚀 👨‍🚀 👩‍⚖️ 🧑‍⚖️ 👨‍⚖️ 👰‍♀️ 👰 👰‍♂️ 🤵‍♀️ 🤵 🤵‍♂️ 👸 🤴 🦸‍♀️ 🦸 🦸‍♂️ 🦹‍♀️ 🦹 🦹‍♂️ 🤶 🧑‍🎄 🎅 🧙‍♀️ 🧙 🧙‍♂️ 🧝‍♀️ 🧝 🧝‍♂️ 🧛‍♀️ 🧛 🧛‍♂️ 🧟‍♀️ 🧟 🧟‍♂️ 🧞‍♀️ 🧞 🧞‍♂️ 🧜‍♀️ 🧜 🧜‍♂️ 🧚‍♀️ 🧚 🧚‍♂️ 👼 🤰 🤱 👩‍🍼 🧑‍🍼 👨‍🍼 🙇‍♀️ 🙇 🙇‍♂️ 💁‍♀️ 💁 💁‍♂️ 🙅‍♀️ 🙅 🙅‍♂️ 🙆‍♀️ 🙆 🙆‍♂️ 🙋‍♀️ 🙋 🙋‍♂️ 🧏‍♀️ 🧏 🧏‍♂️ 🤦‍♀️ 🤦 🤦‍♂️ 🤷‍♀️ 🤷 🤷‍♂️ 🙎‍♀️ 🙎 🙎‍♂️ 🙍‍♀️ 🙍 🙍‍♂️ 💇‍♀️ 💇 💇‍♂️ 💆‍♀️ 💆 💆‍♂️ 🧖‍♀️ 🧖 🧖‍♂️ 💅 🤳 💃 🕺 👯‍♀️ 👯 👯‍♂️ 🕴 👩‍🦽 🧑‍🦽 👨‍🦽 👩‍🦼 🧑‍🦼 👨‍🦼 🚶‍♀️ 🚶 🚶‍♂️ 👩‍🦯 🧑‍🦯 👨‍🦯 🧎‍♀️ 🧎 🧎‍♂️ 🏃‍♀️ 🏃 🏃‍♂️ 🧍‍♀️ 🧍 🧍‍♂️ 👭 🧑‍🤝‍🧑 👬 👫 👩‍❤️‍👩 💑 👨‍❤️‍👨 👩‍❤️‍👨 👩‍❤️‍💋‍👩 💏 👨‍❤️‍💋‍👨 👩‍❤️‍💋‍👨 👪 👨‍👩‍👦 👨‍👩‍👧 👨‍👩‍👧‍👦 👨‍👩‍👦‍👦 👨‍👩‍👧‍👧 👨‍👨‍👦 👨‍👨‍👧 👨‍👨‍👧‍👦 👨‍👨‍👦‍👦 👨‍👨‍👧‍👧 👩‍👩‍👦 👩‍👩‍👧 👩‍👩‍👧‍👦 👩‍👩‍👦‍👦 👩‍👩‍👧‍👧 👨‍👦 👨‍👦‍👦 👨‍👧 👨‍👧‍👦 👨‍👧‍👧 👩‍👦 👩‍👦‍👦 👩‍👧 👩‍👧‍👦 👩‍👧‍👧 🗣 👤 👥';

    const [boxEmoji, setBoxEmoji] = useState(false);

    const [load, setLoad] = useState(false);

    useEffect(() => {
        setBoxEmoji(false);
    }, [conversation]);

    useEffect(() => {
        sendMenssage();
    }, [sending]);

    async function sendMenssage() {
        if (sending === true && load === false) {
            setSending(false);

            if (message) {
                setLoad(true);

                var messageSent = {};

                if (message) {
                    messageSent = {
                        type: 'sent',
                        messageText: message,
                        messageDate: new Date(),
                        status: 'Em Fila',
                        author: document.getElementById('name-user').innerText,
                    };
                }

                sendMessage(messageSent);

                handleScrollToBottom();

                setMessage('');
                setBoxEmoji(false);

                const response = await api.post(
                    'conversations/' + conversation.queueId + '/whatsapp',
                    {
                        mensagem: message,
                    }
                );

                messageSent.id = response.data._id;

                updateStatusMessage(messageSent);

                setLoad(false);
            }
        }
    }

    const [audioBlob, setAudioBlob] = useState('');
    const [statusBlob, setStatusBlob] = useState('stoped');
    const [dateRecord, setDateRecord] = useState(new Date());

    useEffect(() => {
        if (statusBlob === 'sent' && audioBlob) sendAudio(audioBlob);
    }, [statusBlob, audioBlob]);

    async function sendAudio(audioBlob) {
        setLoad(true);

        var formData = new FormData();
        formData.append('file', audioBlob, 'audio.mp3');

        let urlBlob = await api.post('chatbots/upload', formData);

        const messageSent = {
            type: 'sent',
            audio: urlBlob.data.link,
            messageDate: new Date(),
            status: 'Em Fila',
            author: document.getElementById('name-user').innerText,
        };

        sendMessage(messageSent);
        handleScrollToBottom();
        setBoxEmoji(false);

        const response = await api.post(
            'conversations/' + conversation.queueId + '/whatsapp',
            {
                mensagem: urlBlob.data.link,
                tipoDeMensagem: 'audio',
            }
        );

        messageSent.id = response.data._id;

        updateStatusMessage(messageSent);

        setLoad(false);
    }

    async function sendMedias() {
        setLoad(true);

        var messageSent = {};
        var tipo = '';

        if (uploadArquivo.fileInfos.type.split('audio').length > 1) {
            tipo = 'audio';
            messageSent = {
                type: 'sent',
                audio: uploadArquivo.url,
                messageText: '',
                messageDate: new Date(),
                status: 'Em Fila',
                author: document.getElementById('name-user').innerText,
            };
        } else if (uploadArquivo.fileInfos.type.split('video').length > 1) {
            tipo = 'video';
            messageSent = {
                type: 'sent',
                video: uploadArquivo.url,
                messageText: '',
                messageDate: new Date(),
                status: 'Em Fila',
                author: document.getElementById('name-user').innerText,
            };
        } else if (uploadArquivo.fileInfos.type.split('image').length > 1) {
            tipo = 'image';
            messageSent = {
                type: 'sent',
                foto: uploadArquivo.url,
                messageText: '',
                messageDate: new Date(),
                status: 'Em Fila',
                author: document.getElementById('name-user').innerText,
            };
        } else {
            tipo = 'file';
            messageSent = {
                type: 'sent',
                arquivo: uploadArquivo.url,
                messageText: '',
                messageDate: new Date(),
                status: 'Em Fila',
                author: document.getElementById('name-user').innerText,
            };
        }

        sendMessage(messageSent);
        handleScrollToBottom();
        setBoxEmoji(false);

        const response = await api.post(
            'conversations/' + conversation.queueId + '/whatsapp',
            {
                mensagem: uploadArquivo.url,
                tipoDeMensagem: tipo,
            }
        );

        messageSent.id = response.data._id;

        updateStatusMessage(messageSent);

        setUploadArquivo({});
        setLoad(false);
    }

    function checkSubmit(e) {
        if (!e.shiftKey && e.key === 'Enter') {
            setSending(true);
        }
    }

    function insertEmoji(val) {
        const step = refContentEditable.current;

        step.focus();

        var selection = window.getSelection();

        for (var i = 0; i < step; i += 1) {
            selection.modify('extend', 'backward', 'character');
        }

        document.execCommand('insertText', false, val);
    }

    function replaceEmoji(text) {
        text = text.replace(':D', '😁');
        text = text.replace(':(', '🙁');
        text = text.replace(':)', '😀');
        text = text.replace(';(', '😢');
        text = text.replace(';)', '😉');
        text = text.replace('<3', '❤️');
        return text;
    }

    function startRecord(func = () => {}) {
        setDateRecord(new Date());
        func();
    }

    const [submenuMedias, setSubmenuMedias] = useState(false);

    const [uploadArquivo, setUploadArquivo] = useState('');

    async function handleOnUpload(e, tipo = '') {
        const nameFileName = e.target.files[0].name;
        const fileInfos = e.target.files[0];

        var formData = new FormData();
        formData.append('file', e.target.files[0], nameFileName);

        let response = await api.post('chatbots/upload', formData);

        setUploadArquivo({
            tipoBotao: tipo,
            fileInfos: fileInfos,
            url: response.data.link,
        });

        setSubmenuMedias(false);
    }

    return (
        <div className="sent-message">
            {uploadArquivo.url && (
                <div className="preview-send">
                    <div className="head">
                        <button onClick={() => setUploadArquivo({})}>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                                width="24"
                                height="24"
                            >
                                <path
                                    fill="currentColor"
                                    d="M19.1 17.2l-5.3-5.3 5.3-5.3-1.8-1.8-5.3 5.4-5.3-5.3-1.8 1.7 5.3 5.3-5.3 5.3L6.7 19l5.3-5.3 5.3 5.3 1.8-1.8z"
                                ></path>
                            </svg>
                        </button>
                        <span>Pré-visualizar</span>
                    </div>

                    <div className="preview">
                        {uploadArquivo.fileInfos.type.split('image').length >
                            1 && <img src={uploadArquivo.url} />}

                        {uploadArquivo.fileInfos.type.split('video').length >
                            1 && (
                            <video width="320" height="240" controls>
                                <source
                                    src={uploadArquivo.url}
                                    type="video/mp4"
                                />
                                <source
                                    src={uploadArquivo.url}
                                    type="video/ogg"
                                />
                            </video>
                        )}

                        {uploadArquivo.fileInfos.type.split('audio').length >
                            1 && (
                            <audio controls>
                                <source
                                    src={uploadArquivo.url}
                                    type="audio/ogg"
                                />
                                <source
                                    src={uploadArquivo.url}
                                    type="audio/mpeg"
                                />
                            </audio>
                        )}

                        {uploadArquivo.fileInfos.type.split('video').length ===
                            1 &&
                            uploadArquivo.fileInfos.type.split('image')
                                .length === 1 &&
                            uploadArquivo.fileInfos.type.split('audio')
                                .length === 1 && (
                                <img
                                    src={
                                        'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADMAAAA8CAYAAADL94L/AAAByElEQVR4Ae3axdJTQRAFYFyegA3u8ALseCDcicsGhxt3x+G32BXc3X3NBnfXYTqp3sZlhuqpOlXZRL46He9ReJyJxGSTEreaPfEHZiX+1uSJvelVNu+Jvjd7Yk9zI8aSUe0eDpjCIYfNSuw5v/zF5In/6mU27478tXriLJvXjdSwPq1lCDTCmxjiCNav8GZYBVMwWKagX8kWjk9vCcMhYWhEFEw1+oV0wZjdPKY6Vn9EwmBDTYPwBoXCYPLGDQTJjkHQNQRJj0FQtmgs+C8wOHIIkh2DoDu5vD5Xfkz9hsTBWDyxhjDYUDqvLRYSY1JilSQGyyxXOt4QKJPX70NDQmI27gyxHcn9bH/5RFMNAUgoDI4afOAMHBiCdiDNj5woGAhgsCEYudSI1lBCRwoPL957slAoDDYEoPXb/ZVs3FE/y9072fDxsx4BMPVfGOpl1VY/y5++4EWM1Fm9LcCKpy8RpnchDGEIQxjCEIYwhCEMYQhDGMIQhjCEIQxhCEMYwhCGMIQhDGEIQxhYNlXiP+XHXLRDM5thQVpyzIfS2YtLceVEkRmzalsgMArPhp258bA6b/LEb8LqPM930VNdvY/fhMmCxw+Of+4BTcPInBo2AAAAAElFTkSuQmCC'
                                    }
                                />
                            )}

                        <span>{uploadArquivo.fileInfos.name}</span>

                        <button
                            className="button-zig column full secondary"
                            onClick={sendMedias}
                        >
                            {load === true ? 'Enviando...' : 'Enviar'}
                        </button>
                    </div>
                </div>
            )}

            <div className="emojis">
                <div className={`list ${boxEmoji ? 'active' : 'hidden'}`}>
                    <Scrollbars style={{ width: '100%', height: '100%' }}>
                        {emojis.split(' ').map((row, key) => (
                            <button onClick={() => insertEmoji(row)} key={key}>
                                {row}
                            </button>
                        ))}
                    </Scrollbars>
                </div>
            </div>

            <div className="visible">
                {conversation.ativo && (
                    <>
                        <div className="emojis">
                            <div
                                className={`buttons ${
                                    boxEmoji ? 'active' : ''
                                }`}
                            >
                                <button
                                    className="close"
                                    onClick={() => setBoxEmoji(false)}
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 24 24"
                                        width="24"
                                        height="24"
                                    >
                                        <path
                                            fill="currentColor"
                                            d="M19.1 17.2l-5.3-5.3 5.3-5.3-1.8-1.8-5.3 5.4-5.3-5.3-1.8 1.7 5.3 5.3-5.3 5.3L6.7 19l5.3-5.3 5.3 5.3 1.8-1.8z"
                                        ></path>
                                    </svg>
                                </button>

                                <button
                                    className="open"
                                    onClick={() => setBoxEmoji(true)}
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 24 24"
                                        width="24"
                                        height="24"
                                    >
                                        <path
                                            fill="currentColor"
                                            d="M9.153 11.603c.795 0 1.439-.879 1.439-1.962s-.644-1.962-1.439-1.962-1.439.879-1.439 1.962.644 1.962 1.439 1.962zm-3.204 1.362c-.026-.307-.131 5.218 6.063 5.551 6.066-.25 6.066-5.551 6.066-5.551-6.078 1.416-12.129 0-12.129 0zm11.363 1.108s-.669 1.959-5.051 1.959c-3.505 0-5.388-1.164-5.607-1.959 0 0 5.912 1.055 10.658 0zM11.804 1.011C5.609 1.011.978 6.033.978 12.228s4.826 10.761 11.021 10.761S23.02 18.423 23.02 12.228c.001-6.195-5.021-11.217-11.216-11.217zM12 21.354c-5.273 0-9.381-3.886-9.381-9.159s3.942-9.548 9.215-9.548 9.548 4.275 9.548 9.548c-.001 5.272-4.109 9.159-9.382 9.159zm3.108-9.751c.795 0 1.439-.879 1.439-1.962s-.644-1.962-1.439-1.962-1.439.879-1.439 1.962.644 1.962 1.439 1.962z"
                                        ></path>
                                    </svg>
                                </button>
                            </div>
                        </div>
                        <div
                            className={`send-medias ${
                                submenuMedias === true ? 'active' : 'inactive'
                            }`}
                        >
                            <div className="submenu-media">
                                <button>
                                    <span>
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 53 53"
                                            width="53"
                                            height="53"
                                        >
                                            <defs>
                                                <circle
                                                    id="image-SVGID_1_"
                                                    cx="26.5"
                                                    cy="26.5"
                                                    r="25.5"
                                                ></circle>
                                            </defs>
                                            <use overflow="visible"></use>
                                            <g clip-path="url(#image-SVGID_2_)">
                                                <path
                                                    fill="#AC44CF"
                                                    d="M26.5-1.1C11.9-1.1-1.1 5.6-1.1 27.6h55.2c-.1-19-13-28.7-27.6-28.7z"
                                                ></path>
                                                <path
                                                    fill="#BF59CF"
                                                    d="M53 26.5H-1.1c0 14.6 13 27.6 27.6 27.6s27.6-13 27.6-27.6H53z"
                                                ></path>
                                                <path
                                                    fill="#AC44CF"
                                                    d="M17 24.5h18v9H17z"
                                                ></path>
                                            </g>
                                            <g fill="#F5F5F5">
                                                <path
                                                    id="svg-image"
                                                    d="M18.318 18.25h16.364c.863 0 1.727.827 1.811 1.696l.007.137v12.834c0 .871-.82 1.741-1.682 1.826l-.136.007H18.318a1.83 1.83 0 0 1-1.812-1.684l-.006-.149V20.083c0-.87.82-1.741 1.682-1.826l.136-.007h16.364zm5.081 8.22l-3.781 5.044c-.269.355-.052.736.39.736h12.955c.442-.011.701-.402.421-.758l-2.682-3.449a.54.54 0 0 0-.841-.011l-2.262 2.727-3.339-4.3a.54.54 0 0 0-.861.011zm8.351-5.22a1.75 1.75 0 1 0 .001 3.501 1.75 1.75 0 0 0-.001-3.501z"
                                                ></path>
                                            </g>
                                        </svg>
                                    </span>
                                    <input
                                        onChange={(e) =>
                                            handleOnUpload(e, 'imagem')
                                        }
                                        accept="image/*,video/mp4,video/3gpp,video/quicktime"
                                        type="file"
                                    />
                                </button>
                                <button>
                                    <span>
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 53 53"
                                            width="53"
                                            height="53"
                                        >
                                            <defs>
                                                <circle
                                                    id="document-SVGID_1_"
                                                    cx="26.5"
                                                    cy="26.5"
                                                    r="25.5"
                                                ></circle>
                                            </defs>
                                            <g clip-path="url(#document-SVGID_2_)">
                                                <path
                                                    fill="#5157AE"
                                                    d="M26.5-1.1C11.9-1.1-1.1 5.6-1.1 27.6h55.2c-.1-19-13-28.7-27.6-28.7z"
                                                ></path>
                                                <path
                                                    fill="#5F66CD"
                                                    d="M53 26.5H-1.1c0 14.6 13 27.6 27.6 27.6s27.6-13 27.6-27.6H53z"
                                                ></path>
                                            </g>
                                            <g fill="#F5F5F5">
                                                <path
                                                    id="svg-document"
                                                    d="M29.09 17.09c-.38-.38-.89-.59-1.42-.59H20.5c-1.1 0-2 .9-2 2v16c0 1.1.89 2 1.99 2H32.5c1.1 0 2-.9 2-2V23.33c0-.53-.21-1.04-.59-1.41l-4.82-4.83zM27.5 22.5V18l5.5 5.5h-4.5c-.55 0-1-.45-1-1z"
                                                ></path>
                                            </g>
                                        </svg>
                                    </span>
                                    <input
                                        onChange={(e) =>
                                            handleOnUpload(e, 'arquivo')
                                        }
                                        accept="*"
                                        type="file"
                                    />
                                </button>
                            </div>

                            <button
                                className="send-menu"
                                onClick={() => setSubmenuMedias(!submenuMedias)}
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 24 24"
                                    width="24"
                                    height="24"
                                >
                                    <path
                                        fill="currentColor"
                                        d="M1.816 15.556v.002c0 1.502.584 2.912 1.646 3.972s2.472 1.647 3.974 1.647a5.58 5.58 0 0 0 3.972-1.645l9.547-9.548c.769-.768 1.147-1.767 1.058-2.817-.079-.968-.548-1.927-1.319-2.698-1.594-1.592-4.068-1.711-5.517-.262l-7.916 7.915c-.881.881-.792 2.25.214 3.261.959.958 2.423 1.053 3.263.215l5.511-5.512c.28-.28.267-.722.053-.936l-.244-.244c-.191-.191-.567-.349-.957.04l-5.506 5.506c-.18.18-.635.127-.976-.214-.098-.097-.576-.613-.213-.973l7.915-7.917c.818-.817 2.267-.699 3.23.262.5.501.802 1.1.849 1.685.051.573-.156 1.111-.589 1.543l-9.547 9.549a3.97 3.97 0 0 1-2.829 1.171 3.975 3.975 0 0 1-2.83-1.173 3.973 3.973 0 0 1-1.172-2.828c0-1.071.415-2.076 1.172-2.83l7.209-7.211c.157-.157.264-.579.028-.814L11.5 4.36a.572.572 0 0 0-.834.018l-7.205 7.207a5.577 5.577 0 0 0-1.645 3.971z"
                                    ></path>
                                </svg>
                            </button>
                        </div>
                    </>
                )}

                <div className="input">
                    {conversation.ativo &&
                    conversation.falarComAtendente === true ? (
                        <>
                            <ContentEditable
                                id="input-send"
                                innerRef={refContentEditable}
                                html={message}
                                disabled={false}
                                onChange={(e) =>
                                    setMessage(
                                        replaceEmoji(e.currentTarget.innerText)
                                    )
                                }
                                onKeyDown={checkSubmit}
                            />

                            {!message && <span>Digite uma mensagem</span>}
                        </>
                    ) : (
                        <div
                            id="input-send"
                            style={{
                                opacity: 0.3,
                                alignItems: 'center',
                                display: 'flex',
                            }}
                        >
                            <svg
                                style={{ marginRight: 10 }}
                                xmlns="http://www.w3.org/2000/svg"
                                aria-hidden="true"
                                focusable="false"
                                width="1em"
                                height="1em"
                                preserveAspectRatio="xMidYMid meet"
                                viewBox="0 0 16 16"
                            >
                                <g fill="#626262">
                                    <path
                                        fill-rule="evenodd"
                                        clip-rule="evenodd"
                                        d="M8.6 1c1.6.1 3.1.9 4.2 2c1.3 1.4 2 3.1 2 5.1c0 1.6-.6 3.1-1.6 4.4c-1 1.2-2.4 2.1-4 2.4c-1.6.3-3.2.1-4.6-.7c-1.4-.8-2.5-2-3.1-3.5C.9 9.2.8 7.5 1.3 6c.5-1.6 1.4-2.9 2.8-3.8C5.4 1.3 7 .9 8.6 1zm.5 12.9c1.3-.3 2.5-1 3.4-2.1c.8-1.1 1.3-2.4 1.2-3.8c0-1.6-.6-3.2-1.7-4.3c-1-1-2.2-1.6-3.6-1.7c-1.3-.1-2.7.2-3.8 1c-1.1.8-1.9 1.9-2.3 3.3c-.4 1.3-.4 2.7.2 4c.6 1.3 1.5 2.3 2.7 3c1.2.7 2.6.9 3.9.6zM7.9 7.5L10.3 5l.7.7l-2.4 2.5l2.4 2.5l-.7.7l-2.4-2.5l-2.4 2.5l-.7-.7l2.4-2.5l-2.4-2.5l.7-.7l2.4 2.5z"
                                    />
                                </g>
                                <rect
                                    x="0"
                                    y="0"
                                    width="16"
                                    height="16"
                                    fill="rgba(0, 0, 0, 0)"
                                />
                            </svg>
                            Chat inativo
                        </div>
                    )}
                </div>

                {conversation.ativo && (
                    <div className="audio-record">
                        <ReactMediaRecorder
                            audio
                            render={({
                                status,
                                startRecording,
                                stopRecording,
                                mediaBlobUrl,
                                clearBlobUrl,
                            }) => (
                                <div>
                                    {status !== 'recording' ? (
                                        <button
                                            className="start-record"
                                            onClick={() =>
                                                startRecord(startRecording)
                                            }
                                        >
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                viewBox="0 0 24 24"
                                                width="24"
                                                height="24"
                                            >
                                                <path
                                                    fill="currentColor"
                                                    d="M11.999 14.942c2.001 0 3.531-1.53 3.531-3.531V4.35c0-2.001-1.53-3.531-3.531-3.531S8.469 2.35 8.469 4.35v7.061c0 2.001 1.53 3.531 3.53 3.531zm6.238-3.53c0 3.531-2.942 6.002-6.237 6.002s-6.237-2.471-6.237-6.002H3.761c0 4.001 3.178 7.297 7.061 7.885v3.884h2.354v-3.884c3.884-.588 7.061-3.884 7.061-7.885h-2z"
                                                ></path>
                                            </svg>
                                        </button>
                                    ) : (
                                        <div className="recording-audio">
                                            <button
                                                className="close"
                                                onClick={() => {
                                                    stopRecording();
                                                    setStatusBlob('canceled');
                                                }}
                                            >
                                                <svg viewBox="0 0 16 16">
                                                    <g fill="#626262">
                                                        <path
                                                            fill-rule="evenodd"
                                                            clip-rule="evenodd"
                                                            d="M8 8.707l3.646 3.647l.708-.707L8.707 8l3.647-3.646l-.707-.708L8 7.293L4.354 3.646l-.707.708L7.293 8l-3.646 3.646l.707.708L8 8.707z"
                                                        />
                                                    </g>
                                                    <rect
                                                        x="0"
                                                        y="0"
                                                        width="16"
                                                        height="16"
                                                        fill="rgba(0, 0, 0, 0)"
                                                    />
                                                </svg>
                                            </button>

                                            <CountdownReverse
                                                dateDuration={dateRecord}
                                            />

                                            <button
                                                onClick={() => {
                                                    stopRecording();
                                                    setStatusBlob('sent');
                                                }}
                                                className="check"
                                            >
                                                <svg viewBox="0 0 24 24">
                                                    <g fill="none">
                                                        <path
                                                            d="M4 12l6 6L20 6"
                                                            stroke="#626262"
                                                            strokeWidth="2"
                                                            stroke-linecap="round"
                                                            stroke-linejoin="round"
                                                        />
                                                    </g>
                                                    <rect
                                                        x="0"
                                                        y="0"
                                                        width="24"
                                                        height="24"
                                                        fill="rgba(0, 0, 0, 0)"
                                                    />
                                                </svg>
                                            </button>
                                        </div>
                                    )}
                                </div>
                            )}
                            onStop={(blobUrl, blob) => setAudioBlob(blob)}
                        />
                    </div>
                )}
            </div>
        </div>
    );
}
